import { Colors } from '@cognite/cogs.js';

export const MenuItemsStyles = {
  fontWeight: 500,
  whiteSpace: 'normal',
  width: '100%',
  '.option_description': {
    fontSize: 12,
    lineHeight: 16,
  },
};

export const MenuItemDeleteStyles = {
  ...MenuItemsStyles,
  color: Colors['decorative--red--500'],
};

export const OptionDescriptionStyles = {
  color: 'var(--cogs-text-hint)',
  fontSize: 12,
};
